export const TIMEFRAME = {
  pay_stubs: {
    max_value: 3,
    unit: "month"
  },
  bank_statements: {
    max_value: 3,
    unit: "month"
  },
  w2: {
    max_value: 2,
    unit: "year"
  },
  tax_returns: {
    max_value: 2,
    unit: "year"
  }
};
